var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 20.25C8.85169 20.25 8.70668 20.206 8.58334 20.1236C8.45999 20.0412 8.36386 19.9241 8.30709 19.787C8.25032 19.65 8.23547 19.4992 8.26441 19.3537C8.29335 19.2082 8.36479 19.0746 8.46968 18.9697L15.4393 12L8.46968 5.03036C8.32903 4.88971 8.25001 4.69894 8.25001 4.50002C8.25001 4.3011 8.32903 4.11033 8.46968 3.96968C8.61034 3.82902 8.80111 3.75 9.00003 3.75C9.19895 3.75 9.38972 3.82902 9.53037 3.96968L17.0304 11.4697C17.1 11.5393 17.1553 11.622 17.193 11.713C17.2307 11.804 17.2501 11.9015 17.2501 12C17.2501 12.0985 17.2307 12.196 17.193 12.287C17.1553 12.378 17.1 12.4607 17.0304 12.5304L9.53037 20.0304C9.4608 20.1001 9.37813 20.1554 9.28712 20.1931C9.19611 20.2308 9.09854 20.2502 9.00003 20.25Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.e62a20619b21897603b600d3c127a271.svg";
export { ForwardRef as ReactComponent };